import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import {IconoirServer} from '@ey-xd/motif-icon';

import Module from '..';

const GRAModule = ({onClick}) => {
	const props = {
		icon: IconoirServer,
		label: labels.groupRiskAssessment,
		onClick
	};

	return <Module {...props} />;
};

GRAModule.propTypes = {};

GRAModule.defaultProps = {};

export default GRAModule;
